import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppFrame } from "./components/AppFrame";
import { PageLoader } from "./components/PageLoader";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const LandingPageB = lazy(() => import("./pages/LandingPageB"));
const QuizPage = lazy(() => import("./pages/QuizPage"));
const ResultPage = lazy(() => import("./pages/ResultPage"));
const OfferPage = lazy(() => import("./pages/OfferPage"));
const CheckoutPage = lazy(() => import("./pages/CheckoutPage"));
const ThankYouPage = lazy(() => import("./pages/ThankYouPage"));
const LegalPage = lazy(() => import("./pages/LegalPage"));
const PreferencesPage = lazy(() => import("./pages/PreferencesPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const StatusPage = lazy(() => import("./pages/StatusPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

export function App() {
  return (
    <AppFrame>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/b" element={<LandingPageB />} />
          <Route path="/b/quiz" element={<QuizPage variant="B" />} />
          <Route path="/b/quiz/resultado/:token" element={<ResultPage variant="B" />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/quiz/resultado/:token" element={<ResultPage />} />
          <Route path="/oferta/:token" element={<OfferPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/obrigado" element={<ThankYouPage />} />
          <Route path="/privacidade" element={<LegalPage kind="privacy" />} />
          <Route path="/termos" element={<LegalPage kind="terms" />} />
          <Route path="/preferencias" element={<PreferencesPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/b/offline" element={<StatusPage kind="offline" variant="B" />} />
          <Route path="/b/sessao-expirada" element={<StatusPage kind="expired" variant="B" />} />
          <Route path="/b/erro" element={<StatusPage kind="error" variant="B" />} />
          <Route
            path="/offline"
            element={<StatusPage kind="offline" />}
          />
          <Route
            path="/sessao-expirada"
            element={<StatusPage kind="expired" />}
          />
          <Route path="/erro" element={<StatusPage kind="error" />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/inicio" element={<Navigate replace to="/" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </AppFrame>
  );
}
